import { OpenInNew } from '@mui/icons-material';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export interface OpenAOIProps {
  AOI: unknown;
  variant?: 'IconOnly' | 'IconAndText';
}

export const OpenAOIComponent: React.FC<OpenAOIProps> = ({ AOI, variant = 'IconAndText' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Button
      variant="contained"
      component={RouterLink}
      to="/survey-request"
      state={{ AOI }}
      sx={{
        flex: 1,
        textAlign: 'center',
        display: { xs: 'none', sm: 'flex' },
        backgroundColor: 'var(--clover-green)', // Set the background color to --sundrop-yellow
        color: 'var(--gentian-white)', // Set the text color to --gentian-black for contrast
        '&:hover': {
          backgroundColor: 'var(--eclipse-black)',
        },
      }}
    >
      {!isMobile && variant === 'IconAndText' && 'Open'} <OpenInNew />
    </Button>
  );
};
